import { State } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineState,
  ProductBuilderMachineStateSchema,
} from '../types';

type IsCurrentState = (
  stateValue: ProductBuilderMachineState,
  state: State<
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema
  >,
) => boolean;

export const isCurrentState: IsCurrentState = (stateValue, state) => {
  return state.matches(stateValue);
};
